/**
 * CuidaDF - Tela de Resultado
 *
 * Mostra o direcionamento (nao diagnostico) e a unidade recomendada.
 */

import React from "react";
import "../styles/Resultado.css";
import logoInstituto from "../assets/logo-instituto.png";

const ESTILO_POR_DIRECIONAMENTO = {
  urgente: { cor: "vermelho", emoji: "🚨" },
  upa_hoje: { cor: "laranja", emoji: "⚠️" },
  ubs_agendar: { cor: "verde", emoji: "✅" },
};

function Resultado({ resultado, onNovaTriagem }) {
  const { direcionamento, unidade_recomendada, unidades_alternativas, numero_samu } = resultado;
  const estilo = ESTILO_POR_DIRECIONAMENTO[direcionamento.direcionamento] || ESTILO_POR_DIRECIONAMENTO.upa_hoje;

  function formatarTempo(minutos) {
    if (minutos < 60) return `${minutos}min`;
    const horas = Math.floor(minutos / 60);
    const min = minutos % 60;
    return min > 0 ? `${horas}h${min}` : `${horas}h`;
  }

  return (
    <div className="tela-resultado">
      <div className={`resultado-header cor-${estilo.cor}`}>
        <div className="urgencia-badge">{estilo.emoji}</div>
        <p className="urgencia-label">{direcionamento.titulo}</p>
        <p className="resultado-mensagem">{direcionamento.mensagem}</p>
      </div>

      <div className="resultado-content">
        {direcionamento.mostrar_samu && (
          <div className="samu-card">
            <p className="samu-titulo">Em caso de emergência, ligue:</p>
            <a href={`tel:${numero_samu}`} className="samu-numero">
              📞 SAMU {numero_samu}
            </a>
          </div>
        )}

        {unidade_recomendada && (
          <div className="unidade-card recomendada">
            <p className="unidade-tag rec">⭐ Recomendada para você</p>
            <p className="unidade-nome">{unidade_recomendada.nome}</p>
            <p className="unidade-end">📍 {unidade_recomendada.endereco}</p>
            <div className="unidade-stats">
              {unidade_recomendada.tipo !== "UBS" && (
                <div className="stat">
                  <p className="stat-val">{formatarTempo(unidade_recomendada.tempo_espera_minutos)}</p>
                  <p className="stat-label">
                    {unidade_recomendada.fonte_tempo === "powerbi_igesdf" ? "Espera real" : "Espera estimada"}
                  </p>
                </div>
              )}
              {unidade_recomendada.distancia_km != null && (
                <div className="stat">
                  <p className="stat-val">{unidade_recomendada.distancia_km}km</p>
                  <p className="stat-label">Distância</p>
                </div>
              )}
              {unidade_recomendada.tipo === "UBS" && (
                <div className="stat">
                  <p className="stat-val" style={{fontSize: "13px", color: "#3B9DD4"}}>Demanda</p>
                  <p className="stat-label">Espontânea</p>
                </div>
              )}
            </div>
            <a
              className="btn-ir"
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(unidade_recomendada.nome + ", " + unidade_recomendada.endereco + ", Distrito Federal")}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              🗺️ Ver no mapa
            </a>
          </div>
        )}

        {unidades_alternativas && unidades_alternativas.length > 0 && (
          <>
            <p className="section-label">Outras opções próximas</p>
            {unidades_alternativas.map((unidade, idx) => (
              <div key={idx} className="unidade-card alternativa">
                <p className="unidade-tag alt">{unidade.tipo}</p>
                <p className="unidade-nome">{unidade.nome}</p>
                <p className="unidade-end">📍 {unidade.endereco}</p>
                <div className="unidade-stats">
                  {unidade.tipo !== "UBS" && (
                    <div className="stat">
                      <p className="stat-val">{formatarTempo(unidade.tempo_espera_minutos)}</p>
                      <p className="stat-label">Espera atual</p>
                    </div>
                  )}
                  {unidade.distancia_km != null && (
                    <div className="stat">
                      <p className="stat-val">{unidade.distancia_km}km</p>
                      <p className="stat-label">Distância</p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </>
        )}

        <p className="aviso-rodape">
          O CuidaDF é uma ferramenta de orientação e não substitui avaliação
          profissional de saúde.
        </p>

        <div className="patrocinio-footer">
          <img src={logoInstituto} alt="Instituto Proteção & Amor" className="patrocinio-logo" />
          <p>Serviço gratuito viabilizado por</p>
          <strong>Instituto Proteção &amp; Amor</strong>
        </div>

        <button className="btn-nova" onClick={onNovaTriagem}>
          Nova avaliação
        </button>
      </div>
    </div>
  );
}

export default Resultado;
